import React from "react";
import { Modal } from "react-bootstrap";

// Styles
import "./DeleteModal.scss";

const DeleteModal = ({ title, description, show, handleClose, handleDelete }) => {
  return (
    <Modal
      className="delete-modal"
      size="md"
      centered
      show={show}
      onHide={handleClose}
      style={{ backgroundColor: "rgba(0,0,0,0.4)" }}
    >
      <div role="document" className="modal-md">
        <div className="modal-header is-size-h4 bold">{title}</div>
        <div className="modal-body">
          <div className="is-size-body-1 d-flex">{description}</div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn-secondary" onClick={handleClose}>
            Cancel
          </button>
          <button type="button" className="btn-danger-filled" onClick={handleDelete}>
            Yes
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
